import { tempInterviewGroups, type InterviewGroup } from './tempInterviewGroups'

export type InterviewType = 'GENERAL' | 'SKILL' | 'APPLICATION'

export type Interview = {
  id_slug: string
  created_date: string
  interview_type: InterviewType
  language: 'cantonese' | 'english' | 'mandarin (realtime speed)' | string
  voice: 'alloy' | string
  model_mode: 'REALTIME_SPEED' | 'REALTIME_STANDARD' | string
  start_datetime: string | null
  end_datetime: string | null
  status: 'COMPLETED' | 'STARTED' | 'FAILED' | 'NOT_STARTED'
  allow_start_datetime: string | null
  allow_end_datetime: string | null
  user_id_slug: string | null // user who will have access to this interview
  admin_part: {
    feedback_ai_detected: boolean | null
    feedback_json: object | null
    feedback_score: number | null
    feedback_summary: string | null
  }
  error_part: {
    error_message: string
    resolved: boolean
  } | null
  // hardware
  hardware_info?: string | null
  video_chunk_upload_latency?: string | null
}

export type InterviewExtend = Interview & {
  allow_open_always: boolean
  group: InterviewGroup // Foreign object link
}

export type InterviewSessionAssessmentCard = InterviewExtend & {
  user_data: {
    first_name: string
    last_name: string
    email: string
    profile_image: {
      presigned_get_object_url: string
    }
  }
}

const kydp = tempInterviewGroups[0]
const general = tempInterviewGroups[1]
const careerFair = tempInterviewGroups[2]

export const tempInterviews: InterviewExtend[] = [
  {
    id_slug: 'interview-id-slug-0',
    created_date: '2025-01-01T10:00:00',
    interview_type: 'APPLICATION',
    language: 'english',
    voice: 'alloy',
    model_mode: 'REALTIME_SPEED',
    start_datetime: '2025-01-01T10:00:00',
    end_datetime: '2025-04-01T10:00:00',
    status: 'NOT_STARTED',
    admin_part: {
      feedback_ai_detected: null,
      feedback_json: null,
      feedback_score: null,
      feedback_summary: null
    },
    allow_open_always: false,
    allow_start_datetime: '2025-01-01T10:00:00',
    allow_end_datetime: '2025-04-01T10:00:00',
    user_id_slug: 'me',
    group: kydp,
    error_part: null
  },
  {
    id_slug: 'interview-id-slug-0-1',
    created_date: '2025-01-01T10:00:00',
    interview_type: 'APPLICATION',
    language: 'english',
    voice: 'alloy',
    model_mode: 'REALTIME_SPEED',
    start_datetime: '2025-01-01T10:00:00',
    end_datetime: '2025-04-01T10:00:00',
    status: 'NOT_STARTED',
    admin_part: {
      feedback_ai_detected: null,
      feedback_json: null,
      feedback_score: null,
      feedback_summary: null
    },
    allow_open_always: false,
    allow_start_datetime: '2025-01-01T10:00:00',
    allow_end_datetime: '2025-04-01T10:00:00',
    user_id_slug: 'me',
    group: kydp,
    error_part: null
  },
  {
    id_slug: 'interview-id-slug-0-2',
    created_date: '2025-01-01T10:00:00',
    interview_type: 'APPLICATION',
    language: 'english',
    voice: 'alloy',
    model_mode: 'REALTIME_SPEED',
    start_datetime: '2025-01-01T10:00:00',
    end_datetime: '2025-04-01T10:00:00',
    status: 'NOT_STARTED',
    admin_part: {
      feedback_ai_detected: null,
      feedback_json: null,
      feedback_score: null,
      feedback_summary: null
    },
    allow_open_always: false,
    allow_start_datetime: '2025-01-01T10:00:00',
    allow_end_datetime: '2025-04-01T10:00:00',
    user_id_slug: 'me',
    group: kydp,
    error_part: null
  },
  {
    id_slug: 'interview-id-slug-1',
    created_date: '2025-01-01T10:00:00',
    interview_type: 'APPLICATION',
    language: 'english',
    voice: 'alloy',
    model_mode: 'REALTIME_SPEED',
    start_datetime: '2025-01-01T10:00:00',
    end_datetime: '2025-04-01T10:00:00',
    status: 'NOT_STARTED',
    admin_part: {
      feedback_ai_detected: null,
      feedback_json: null,
      feedback_score: null,
      feedback_summary: null
    },
    allow_open_always: false,
    allow_start_datetime: '2025-03-30T10:00:00',
    allow_end_datetime: '2025-04-01T10:00:00',
    user_id_slug: 'me',
    group: careerFair,
    error_part: null
  },
  {
    id_slug: 'yvWqGULnTgOsTZsHKwKCEw',
    created_date: '2025-01-01T10:00:00',
    interview_type: 'APPLICATION',
    language: 'english',
    voice: 'alloy',
    model_mode: 'REALTIME_SPEED',
    start_datetime: '2025-01-01T10:00:00',
    end_datetime: '2025-04-01T10:00:00',
    status: 'COMPLETED',
    admin_part: {
      feedback_ai_detected: false,
      feedback_json: {
        usingAI: false,
        summary: 'Lorem ipsum',
        categories: [
          {
            score: 10,
            category: 'Category 1',
            feedback: [
              {
                nature: 'negative',
                text: 'Lorem ipsum'
              }
            ]
          },
          {
            score: 10,
            category: 'Category 1',
            feedback: [
              {
                nature: 'negative',
                text: 'Lorem ipsum'
              }
            ]
          }
        ]
      },
      feedback_score: 20,
      feedback_summary: 'Lorem ipsum'
    },
    allow_open_always: true,
    allow_start_datetime: null,
    allow_end_datetime: null,
    user_id_slug: 'me',
    group: general,
    error_part: null
  },
  {
    id_slug: 'yvWqGULnTgOsTZsHKwKCEw',
    created_date: '2025-01-01T10:00:00',
    interview_type: 'APPLICATION',
    language: 'english',
    voice: 'alloy',
    model_mode: 'REALTIME_SPEED',
    start_datetime: '2025-01-01T10:00:00',
    end_datetime: '2025-04-01T10:00:00',
    status: 'COMPLETED',
    admin_part: {
      feedback_ai_detected: false,
      feedback_json: {
        usingAI: false,
        summary: 'Lorem ipsum',
        categories: [
          {
            score: 10,
            category: 'Category 1',
            feedback: [
              {
                nature: 'negative',
                text: 'Lorem ipsum'
              }
            ]
          },
          {
            score: 10,
            category: 'Category 1',
            feedback: [
              {
                nature: 'negative',
                text: 'Lorem ipsum'
              }
            ]
          }
        ]
      },
      feedback_score: 30,
      feedback_summary: 'Lorem ipsum'
    },
    allow_open_always: true,
    allow_start_datetime: null,
    allow_end_datetime: null,
    user_id_slug: 'me',
    group: general,
    error_part: null
  },
  {
    id_slug: '4xsjoV5yRAKqPn_tQDuykQ',
    created_date: '2025-01-01T10:00:00',
    interview_type: 'APPLICATION',
    language: 'english',
    voice: 'alloy',
    model_mode: 'REALTIME_SPEED',
    start_datetime: '2025-01-01T10:00:00',
    end_datetime: '2025-04-01T10:00:00',
    status: 'FAILED',
    admin_part: {
      feedback_ai_detected: null,
      feedback_json: null,
      feedback_score: null,
      feedback_summary: null
    },
    allow_open_always: true,
    allow_start_datetime: null,
    allow_end_datetime: null,
    user_id_slug: 'me',
    group: kydp,
    error_part: {
      error_message: 'I encountered a technical issue during my interview.',
      resolved: false
    }
  }
]

export const interviewTermsAndConditions = [
  `I understand that the interview is conducted using AI technology.`,
  `I understand that the AI may assist the admission team in assessing users' responses based on predefined criteria.`,
  `I understand that AI assessments, scorings and decisions may be reviewed by human recruiters, where applicable.`,
  `I understand that I have the rights to request a human review of AI-generated decisions where applicable.`,
  `I understand that the AI decisions are based on available data and predefined criteria; the platform is not responsible for employer or any external hiring decisions.`,
  `I understand that my responses, voice, video, and text inputs may be recorded and stored.`,
  `I understand that the platform is not liable for technical failures or errors in AI evaluation, but the platform allows for reporting any technical failures to the admission team.`,
  `I understand that the data collected will be used to assess users' fit for the current application, or any future application processes.`,
  `I understand that the data collected will also be used for the purpose of improving our platform, products and services.`,
  `I understand that I have the right to request access, correction, or deletion of my data (subject to legal and operational constraints).`,
  `If employers or third-party recruiters require access to my data, their responsibilities and data processing obligations should be stated.`,
  `I must not attempt to manipulate or misuse the AI system.`,
  `I understand that any impersonations, use of unauthorised software, or AI-assisted cheating are strictly prohibited.`,
  `I understand that the TalentLabs platform does not guarantee employment and admissions to any programme.`,
  `The platform is not liable for any limitations such as, but not limited to: AI inaccuracies or biases, data breaches despite reasonable security measures, users missing interview deadlines due to technical issues.`,
  `The platform reserve the right to update the terms and notify users.`
]
